module.exports = __webpack_public_path__ + "img/9788960510678.4c75789c.jpg";